<div style="display: flex; height: 100%;">
  <div style="display: flex; flex-direction: column; overflow: auto; width: 100%;">
    <div style="display: flex; flex-direction: column; padding: 20px; z-index: 1; ">
      <mat-toolbar color="primary" class="toolbar-over-card"
                   style="padding: 20px; align-items: center; justify-content: space-between;">
        <!-- Title -->
        <div><span>Review Tracking</span></div>
        <div style="display: flex; font-size: medium;">
          <button mat-button aria-label="Add Field" [routerLink]="['/', 'discovery', 'review-sets']" style="padding: 0 16px;">
            <div class="fal fa-ballot-check" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Review Sets</span>
          </button>
          <button *ngIf="viewMode === 'table'" mat-button aria-label="Export" (click)="exportToExcel()" style="padding: 0 16px;">
            <div class="fal fa-file-excel" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Export</span>
          </button>
          <button *ngIf="viewMode === 'graph'" mat-button aria-label="Show Table" (click)="viewMode = 'table'" style="padding: 0 16px;">
            <div class="fal fa-table" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Show Table</span>
          </button>
          <button *ngIf="viewMode === 'table'" mat-button aria-label="Graph" (click)="viewMode = 'graph'" style="padding: 0 16px;">
            <div class="fal fa-line-chart" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Graph</span>
          </button>
          <button mat-button aria-label="Add Field" (click)="displayFilterDialog()" style="padding: 0 16px;">
            <div class="fal fa-plus" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Filters</span>
          </button>
        </div>
      </mat-toolbar>
      <mat-card appearance="outlined" class="card-under-toolbar" style="display: flex;">
        <mat-card-content style="flex: auto; display: flex; flex-direction: column; gap: 10px; min-height: 630px">
          <div style="margin-bottom: 70px;">
            <mat-button-toggle-group [(ngModel)]="unit" (change)="refreshReportData()" style="margin-right: 10px">
              <mat-button-toggle [value]="1">Doc Count</mat-button-toggle>
              <mat-button-toggle [value]="2">Pages</mat-button-toggle>
              <mat-button-toggle [value]="3">GB</mat-button-toggle>
              <mat-button-toggle [value]="4">Activity</mat-button-toggle>
            </mat-button-toggle-group>
            <mat-button-toggle-group [(ngModel)]="dateUnit" (change)="refreshReportData()">
              <mat-button-toggle [value]="1">Daily</mat-button-toggle>
              <mat-button-toggle [value]="2">Hourly</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          <div *ngIf="viewMode === 'table'" style="overflow: auto; height: 100%;">
            <table mat-table *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource" matSort
                   class="table-width" style="width: 100%">
              <ng-container *ngFor="let column of columnsToDisplay" [matColumnDef]="column">
                <th mat-header-cell *matHeaderCellDef matTooltip="In Review" style="width: 250px;" [mat-sort-header]="column">
                  <span *ngIf="column === 'total'">Total</span>
                  <span *ngIf="column === 'date'">Date</span>
                  <span *ngIf="column !== 'total' && column !== 'date'">{{column}}</span>
                </th>
                <td mat-cell *matCellDef="let element">{{round(column, element[column])}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div *ngIf="viewMode === 'graph'"  style="overflow: auto; height: 100%;">
            <ngx-charts-line-chart
              [legend]="true"
              [showXAxisLabel]="true"
              [showYAxisLabel]="true"
              [xAxis]="true"
              [yAxis]="true"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [timeline]="true"
              [results]="chartData"
            >
            </ngx-charts-line-chart>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
